import { render, staticRenderFns } from "./PocUploadVideo.vue?vue&type=template&id=76cca53e&scoped=true"
import script from "./PocUploadVideo.vue?vue&type=script&lang=js"
export * from "./PocUploadVideo.vue?vue&type=script&lang=js"
import style0 from "./PocUploadVideo.vue?vue&type=style&index=0&id=76cca53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cca53e",
  null
  
)

export default component.exports